/**
 * Portal Manta · ESTRUTURAS_TIPOLOGIAS
 * Extraído de App.jsx v29.3 (via AST)
 */
const ESTRUTURAS_TIPOLOGIAS = {
  pavimento: {
    titulo:'Pavimento — Duplicação (A1) e Restauração (REC)',
    mef:{
      camadas:[
        {nome:'Revestimento CBUQ', cm:5,  cor:'#2D2D2D', material:'CAP 50/70 + Faixa C DNIT'},
        {nome:'Binder',             cm:4,  cor:'#444',    material:'CBUQ Faixa B'},
        {nome:'Base',               cm:25, cor:'#A0826D', material:'BGS — brita graduada simples'},
        {nome:'Sub-base',           cm:20, cor:'#C9B79C', material:'Macadame seco / solo-brita'},
        {nome:'Subleito',           cm:60, cor:'#D9C4A8', material:'Solo natural compactado · CBR ≥ 12%'},
      ],
      vida:'10 anos · ESALs 5,0×10⁷',
    },
    manta:{
      camadas:[
        {nome:'Revestimento SMA',    cm:4, cor:'#1A1A1A', material:'Stone Mastic Asphalt — durabilidade +30%'},
        {nome:'Binder PMB',          cm:5, cor:'#3A3A3A', material:'Asfalto modificado por polímero'},
        {nome:'Base BGTC',           cm:22, cor:'#8B6F4E', material:'Brita graduada tratada com cimento (3%)'},
        {nome:'Sub-base estab.',     cm:22, cor:'#B89B7A', material:'Solo-cimento 4% — reaproveita material local'},
        {nome:'Subleito reforçado',  cm:60, cor:'#D9C4A8', material:'Geogrelha + compactação 100% PI'},
      ],
      vida:'15 anos · ESALs 8,0×10⁷',
    },
    consumo_km_pista_dupla:[
      {item:'CBUQ revestimento', un:'t', mef:875,  manta:780,  obs:'Manta usa SMA mais espesso por área mas com mais vazios — economia ~11%'},
      {item:'CBUQ binder',       un:'t', mef:700,  manta:880,  obs:'Manta aumenta camada para extender vida'},
      {item:'CAP / PMB',         un:'t', mef:78,   manta:96,   obs:'PMB é 30% mais caro que CAP, mas reduz manutenção'},
      {item:'Brita graduada',    un:'m³', mef:3500, manta:3100, obs:'BGTC reduz volume por consolidação'},
      {item:'Cimento (estab.)',  un:'t', mef:0,    manta:520,  obs:'Manta introduz BGTC + solo-cimento'},
      {item:'Solo natural local', un:'m³', mef:0,    manta:2800, obs:'Manta reaproveita corte → economia transporte'},
      {item:'Geogrelha PET',     un:'m²', mef:0,    manta:14000, obs:'Reforço subleito · investimento upfront'},
    ],
  },
  oae: {
    titulo:'Obra de Arte Especial — Ponte/Viaduto típico (A9)',
    largura:21.5, // m
    mef:{
      vigamento:'4 vigas pré-moldadas tipo I, h=1,60 m, vão 30 m',
      laje:'Laje pré-moldada + capa concreto in loco fck 35 MPa, h=22 cm',
      tabuleiro:'21,5 m (4 faixas 3,5m + 2 acostamentos 2,5m + barreiras)',
      barreira:'New Jersey concreto fck 30 MPa',
      fundacao:'Estacas escavadas Ø 1,20 m, profundidade 18–24 m',
      vida:'50 anos (NBR 6118)',
    },
    manta:{
      vigamento:'4 vigas pré-moldadas tipo I, h=1,60 m, vão 30 m · OK',
      laje:'Laje pré-fabricada com concreto fck 40 MPa + protensão parcial · h=20 cm (-9%)',
      tabuleiro:'21,5 m · igual ao MEF',
      barreira:'New Jersey concreto fck 35 MPa + cordão drenante lateral',
      fundacao:'Estacas hélice contínua Ø 1,00 m onde NSPT ≥ 25 (em vez de escavadas)',
      vida:'75 anos (NBR 6118 com ações de durabilidade — concreto C40, cobrimento 50mm)',
    },
    consumo_m2:[
      {item:'Concreto fck 35–40 MPa', un:'m³/m²', mef:0.65, manta:0.58, obs:'Lajes mais finas com C40'},
      {item:'Aço CA-50 estrutural',   un:'kg/m²', mef:150,  manta:165,  obs:'Manta usa mais aço por protensão'},
      {item:'Cordoalhas CP-190',      un:'kg/m²', mef:18,   manta:22,   obs:'Protensão adicional'},
      {item:'Forma de madeira',       un:'m²/m²', mef:1.6,  manta:1.3,  obs:'Pré-fabricação reduz forma'},
      {item:'Estaca escavada',        un:'m/m²',  mef:0.85, manta:0.55, obs:'Hélice contínua mais produtiva'},
    ],
  },
  passarela: {
    titulo:'Passarela típica (A10)',
    largura:3.0, vao_tipico:30,
    mef:{
      estrutura:'Treliça metálica em aço A36, vão 30 m',
      tabuleiro:'Chapa metálica + concreto sobreposto h=10 cm',
      pilares:'2 pilares concreto fck 30, seção 0,40 × 0,80 m',
      acesso:'Rampas concreto + escada metálica',
      cobertura:'Não prevista no MEF',
      area_m2:120, // 30m vão + 10m rampas cada lado, 3m largura
    },
    manta:{
      estrutura:'Treliça em aço galvanizado A572 — vida útil +15 anos',
      tabuleiro:'Chapa antiderrapante + concreto + impermeabilização',
      pilares:'Igual ao MEF + reforço sísmico',
      acesso:'Rampas + escada + plataforma elevatória PNE',
      cobertura:'Cobertura policarbonato em todo trecho',
      area_m2:135,
    },
    consumo_un:[
      {item:'Aço estrutural',     un:'t/un', mef:18,  manta:21,  obs:'Galvanização adiciona peso'},
      {item:'Concreto pilares',   un:'m³/un', mef:14, manta:17,  obs:'Reforço sísmico exige seção maior'},
      {item:'Concreto tabuleiro', un:'m³/un', mef:9,  manta:11,  obs:'Camada impermeabilização'},
      {item:'Cobertura policarb', un:'m²/un', mef:0,  manta:90,  obs:'Manta inclui cobertura'},
      {item:'Plataforma PNE',     un:'un',   mef:0,  manta:2,   obs:'Acessibilidade ampliada'},
    ],
  },
};

export { ESTRUTURAS_TIPOLOGIAS };
export default ESTRUTURAS_TIPOLOGIAS;
